import React from "react";

/**
 * Canonical boolean toggle switch, used in place of a native checkbox for
 * standalone on/off settings across the app (list-item selection and
 * bulk-row-selection checkboxes are a different, still-correct convention
 * and are left as native checkboxes). Visually matches the Dashboard Widget
 * Editor's BooleanField (analytics-boolean-control in analytics.css), which
 * was the original design reference.
 */
export const Toggle = ({
  checked,
  onChange,
  disabled = false,
  id,
  ariaLabel,
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  id?: string;
  ariaLabel?: string;
}) => (
  <button
    id={id}
    type="button"
    role="switch"
    aria-checked={checked}
    aria-label={ariaLabel}
    className={`ui-toggle${checked ? " ui-toggle--on" : ""}`}
    disabled={disabled}
    onClick={() => onChange(!checked)}
  >
    <span className="ui-toggle-track" aria-hidden="true">
      <span className="ui-toggle-thumb" />
    </span>
  </button>
);
